import { Product, ProductImageType, ProductType } from '../../context/CartContext';

// Football Images

// Name Only - using existing files
import product_sports_football_jersey_name_pendant1 from '../../assets/images/sports/product_sports_football_jersey_name_pendant1.webp';
import product_sports_football_jersey_name_pendant_large1 from '../../assets/images/sports/product_sports_football_jersey_name_pendant_large1.webp';
import product_sports_football_jersey_name_magnet1 from '../../assets/images/sports/product_sports_football_jersey_name_magnet1.webp';
import product_sports_football_jersey_name_magnet_large1 from '../../assets/images/sports/product_sports_football_jersey_name_magnet_large1.webp';

// Name and Number - using existing files
import product_sports_football_jersey_name_number_pendant1 from '../../assets/images/sports/product_sports_football_jersey_name_number_pendant1.webp';
import product_sports_football_jersey_name_number_pendant_large1 from '../../assets/images/sports/product_sports_football_jersey_name_number_pendant_large1.webp';
import product_sports_football_jersey_name_number_magnet1 from '../../assets/images/sports/product_sports_football_jersey_name_number_magnet1.webp';
import product_sports_football_jersey_name_number_magnet_large1 from '../../assets/images/sports/product_sports_football_jersey_name_number_magnet_large1.webp';

// Name and Number - using existing files
import product_sports_football_jersey_number_keychain1 from '../../assets/images/sports/product_sports_football_jersey_number_keychain1.webp';
import product_sports_football_jersey_number_keychain_large1 from '../../assets/images/sports/product_sports_football_jersey_number_keychain_large1.webp';

// Basketball Images
// Name Only
import product_sports_basketball_jersey_name_pendant1 from '../../assets/images/sports/product_sports_basketball_jersey_name_pendant1.webp';
import product_sports_basketball_jersey_name_pendant_large1 from '../../assets/images/sports/product_sports_basketball_jersey_name_pendant_large1.webp';
import product_sports_basketball_jersey_name_magnet1 from '../../assets/images/sports/product_sports_basketball_jersey_name_magnet1.webp';
import product_sports_basketball_jersey_name_magnet_large1 from '../../assets/images/sports/product_sports_basketball_jersey_name_magnet_large1.webp';

// Name and Number
import product_sports_basketball_jersey_name_number_pendant1 from '../../assets/images/sports/product_sports_basketball_jersey_name_number_pendant1.webp';
import product_sports_basketball_jersey_name_number_pendant_large1 from '../../assets/images/sports/product_sports_basketball_jersey_name_number_pendant_large1.webp';
import product_sports_basketball_jersey_name_number_magnet1 from '../../assets/images/sports/product_sports_basketball_jersey_name_number_magnet1.webp';
import product_sports_basketball_jersey_name_number_magnet_large1 from '../../assets/images/sports/product_sports_basketball_jersey_name_number_magnet_large1.webp';

// Football with Text - using existing files
import product_sports_football_pendant1 from '../../assets/images/sports/product_sports_football_pendant1.webp';
import product_sports_football_pendant_large1 from '../../assets/images/sports/product_sports_football_pendant_large1.webp';
import product_sports_football_magnet1 from '../../assets/images/sports/product_sports_football_magnet1.webp';
import product_sports_football_magnet_large1 from '../../assets/images/sports/product_sports_football_magnet_large1.webp';


// Cheer
import product_sports_cheer_megaphone_pendant1 from '../../assets/images/sports/product_sports_cheer_megaphone_pendant1.webp';
import product_sports_cheer_megaphone_pendant_large1 from '../../assets/images/sports/product_sports_cheer_megaphone_pendant_large1.webp';
import product_sports_cheer_megaphone_magnet1 from '../../assets/images/sports/product_sports_cheer_megaphone_magnet1.webp';
import product_sports_cheer_megaphone_magnet_large1 from '../../assets/images/sports/product_sports_cheer_megaphone_magnet_large1.webp';

// Emblems
import product_sports_emblem_pendant1 from '../../assets/images/sports/product_sports_emblem_pendant1.webp';
import product_sports_emblem_magnet1 from '../../assets/images/sports/product_sports_emblem_magnet1.webp';
import product_sports_emblem_pendant_large1 from '../../assets/images/sports/product_sports_emblem_pendant_large1.webp';
import product_sports_emblem_magnet_large1 from '../../assets/images/sports/product_sports_emblem_magnet_large1.webp';

export const sportsProducts: Product[] = [
  {
    id: '5000',
    name: 'Football Jersey Name Pendant',
    price: 5,
    wholesale_price: 3,
    height_inches: 4.4,
    width_inches: 4.25,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_football_jersey_name_pendant1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_football_jersey_name_pendant_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Charms',
    sub_category: 'Football',
    description: 'Customize your football jersey with your name or team name',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Jersey Text' },
      { name: 'BaseColor', max_length: 20, customText: 'Black' },
      { name: 'TextColor', max_length: 20, customText: 'White' },
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '5001',
    name: 'Football Jersey Name Magnet',
    price: 5,
    wholesale_price: 3,
    height_inches: 4.4,
    width_inches: 4.25,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_football_jersey_name_magnet1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_football_jersey_name_magnet_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Magnets',
    sub_category: 'Football',
    description: 'Customize your football jersey with your name or team name',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Jersey Text' }, 
      { name: 'BaseColor', max_length: 20, customText: 'Black' }, 
      { name: 'TextColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '5002',
    name: 'Football Jersey Name and Number Pendant',
    price: 5,
    wholesale_price: 3,
    height_inches: 4.4,
    width_inches: 4.25,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_football_jersey_name_number_pendant1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_football_jersey_name_number_pendant_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Charms',
    sub_category: 'Football',
    description: 'Customize your football jersey with name and number',
    is_customizeable: true,
    customization_items: [
        { name: 'Name', max_length: 20, customText: 'Jersey Text' }, 
        { name: 'Number', max_length: 3, customText: '50' },
        { name: 'BaseColor', max_length: 20, customText: 'Black' },
        { name: 'TextColor', max_length: 20, customText: 'White' },
        { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '5003',
    name: 'Football Jersey Name and Number Magnet',
    price: 5,
    wholesale_price: 3,
    height_inches: 4.4,
    width_inches: 4.25,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_football_jersey_name_number_magnet1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_football_jersey_name_number_magnet_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Magnets',
    sub_category: 'Football',
    description: 'Customize your football jersey with name and number',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Jersey Text' }, 
      { name: 'Number', max_length: 3, customText: '50' }, 
      { name: 'BaseColor', max_length: 20, customText: 'Black' }, 
      { name: 'TextColor', max_length: 20, customText: 'White' }]
  },
  {
    id: '5004',
    name: 'Football Jersey Name and Number Keychain',
    price: 5,
    wholesale_price: 3,
    height_inches: 2.2,
    width_inches: 2.2,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_football_jersey_number_keychain1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_football_jersey_number_keychain_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Magnets',
    sub_category: 'Football',
    description: 'Customize your football jersey with name and number',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Jersey Text' }, 
      { name: 'Number', max_length: 3, customText: '50' }, 
      { name: 'BaseColor', max_length: 20, customText: 'Black' }, 
      { name: 'TextColor', max_length: 20, customText: 'White' }]
  }, 
  {
    id: '5020',
    name: 'Basketball Jersey Name Pendant',
    price: 5,
    wholesale_price: 3,
    height_inches: 4.4,
    width_inches: 4.25,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_basketball_jersey_name_pendant1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_basketball_jersey_name_pendant_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Charms',
    sub_category: 'Basketball',
    description: 'Customize your basketball jersey with your name or team name',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Jersey Text' },
      { name: 'BaseColor', max_length: 20, customText: 'Black' },
      { name: 'TextColor', max_length: 20, customText: 'White' },
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '5021',
    name: 'Basketball Jersey Name Magnet',
    price: 5,
    wholesale_price: 3,
    height_inches: 4.4,
    width_inches: 4.25,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_basketball_jersey_name_magnet1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_basketball_jersey_name_magnet_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Magnets',
    sub_category: 'Basketball',
    description: 'Customize your basketball jersey with your name or team name',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Jersey Text' }, 
      { name: 'BaseColor', max_length: 20, customText: 'Black' }, 
      { name: 'TextColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '5022',
    name: 'Basketball Jersey Name and Number Pendant',
    price: 5,
    wholesale_price: 3,
    height_inches: 4.4,
    width_inches: 4.25,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_basketball_jersey_name_number_pendant1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_basketball_jersey_name_number_pendant_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Charms',
    sub_category: 'Basketball',
    description: 'Customize your basketball jersey with name and number',
    is_customizeable: true,
    customization_items: [
        { name: 'Name', max_length: 20, customText: 'Jersey Text' }, 
        { name: 'Number', max_length: 3, customText: '50' },
        { name: 'BaseColor', max_length: 20, customText: 'Black' },
        { name: 'TextColor', max_length: 20, customText: 'White' },
        { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '5023',
    name: 'Basketball Jersey Name and Number Magnet',
    price: 5,
    wholesale_price: 3,
    height_inches: 4.4,
    width_inches: 4.25,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_basketball_jersey_name_number_magnet1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_basketball_jersey_name_number_magnet_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Magnets',
    sub_category: 'Basketball',
    description: 'Customize your basketball jersey with name and number',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Jersey Text' }, 
      { name: 'Number', max_length: 3, customText: '50' }, 
      { name: 'BaseColor', max_length: 20, customText: 'Black' }, 
      { name: 'TextColor', max_length: 20, customText: 'White' }]
  },
  {
    id: '5010',
    name: 'Football Pendant with Text',
    price: 5,
    wholesale_price: 3,
    height_inches: 4,
    width_inches: 2.25,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_football_pendant1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_football_pendant_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Charms',
    sub_category: 'Football',
    description: 'Personalized football with any text',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Text' },
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '5011',
    name: 'Football Magnet with Text',
    price: 5,
    wholesale_price: 3,
    height_inches: 4,
    width_inches: 2.25,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_football_magnet1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_football_magnet_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Magnets',
    sub_category: 'Football',
    description: 'Personalized football with any text',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Text' }
    ]
  },
  {
    id: '5050',
    name: 'Cheer Megaphone Pendant',
    price: 5,
    wholesale_price: 3,
    height_inches: 4,
    width_inches: 5.5,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_cheer_megaphone_pendant1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_cheer_megaphone_pendant_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Charms',
    sub_category: 'Cheer',
    description: 'Customize with any text',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Text' }, 
      { name: 'BaseColor', max_length: 20, customText: 'Black' }, 
      { name: 'TextColor', max_length: 20, customText: 'White' },
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '5051',
    name: 'Cheer Megaphone Magnet',
    price: 5,
    wholesale_price: 3,
    height_inches: 4,
    width_inches: 5.5,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_cheer_megaphone_magnet1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_cheer_megaphone_magnet_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.SPORTS,
    category: 'Magnets',
    sub_category: 'Cheer',
    description: 'Customize with any text',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Text' }, 
      { name: 'BaseColor', max_length: 20, customText: 'Black' }, 
      { name: 'TextColor', max_length: 20, customText: 'White' }]
  },
  {
    id: '5100',
    name: 'Emblem Pendant',
    price: 10,
    wholesale_price: 7,
    height_inches: 2,
    width_inches: 3.5,
    depth_inches: 0.25,
    images: [
      { image_path: product_sports_emblem_pendant1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_emblem_pendant_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 15,
    product_type: ProductType.SPORTS,
    category: 'Charms',
    sub_category: 'Emblems',
    description: 'Customize with your own Graphic (We will reach out to you for the image)',
    is_customizeable: true,
    customization_items: [
      { name: 'TeamName', max_length: 20, customText: 'Provide Team Name. We will reach out to preview the image' }, 
      { name: 'BaseColor', max_length: 20, customText: 'Black' }, 
      { name: 'TextColor', max_length: 20, customText: 'White' },
      { name: 'BeadColor', max_length: 20, customText: 'White' }]
  },
  {
    id: '5101',
    name: 'Emblem Magnet',
    height_inches: 2,
    width_inches: 3.5,
    depth_inches: 0.25,
    price: 10,
    wholesale_price: 7,
    images: [
      { image_path: product_sports_emblem_magnet1, image_type: ProductImageType.DETAIL },
      { image_path: product_sports_emblem_magnet_large1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 15,
    product_type: ProductType.SPORTS,
    category: 'Magnets',
    sub_category: 'Emblems',
    description: 'Customize with your own Graphic (We will reach out to you for the image)',
    is_customizeable: true,
    customization_items: [
      { name: 'TeamName', max_length: 20, customText: 'Provide Team Name. We will reach out to preview the image' }, 
      { name: 'BaseColor', max_length: 20, customText: 'Black' }, 
      { name: 'TextColor', max_length: 20, customText: 'White' }]
  }
];
